import { AmplitudeEvent, AmplitudeEventSource } from "@analytics/Amplitude/AmplitudeEvents";

type DateAssignmentMethod = "drag" | "click" | "directly-on-taskboard";
export type DateFilterType = "today" | "overdue";

export class AddTaskToCalendarEvent extends AmplitudeEvent {
    constructor(props: {
        scheduledTime: string;
        numDaysInFuture: number;
        method: DateAssignmentMethod;
        source: AmplitudeEventSource;
        previousTime?: string;
    }) {
        super("add_task_to_calendar");
        this.props = props;
    }
}

export class AssignTaskDurationEvent extends AmplitudeEvent {
    constructor(props: { source: AmplitudeEventSource; previousDuration?: number; duration: number }) {
        super("assign_task_duration");
        this.props = props;
    }
}

export class AssignTaskTimeSpentEvent extends AmplitudeEvent {
    constructor(props: { source: AmplitudeEventSource; timeSpentMins: number }) {
        super("assign_time_spent");
        this.props = props;
    }
}

export class AssignTaskDueDateEvent extends AmplitudeEvent {
    constructor(props: { source: AmplitudeEventSource; dueDate: string }) {
        super("assign_due_date");
        this.props = props;
    }
}

export class AssignTaskDateEvent extends AmplitudeEvent {
    constructor(props: {
        numDaysInFuture: number;
        method: DateAssignmentMethod;
        source: AmplitudeEventSource;
        previousDate?: string;
        date: string;
    }) {
        super("assign_task_date");
        this.props = props;
    }
}

export class CreateTaskEvent extends AmplitudeEvent {
    constructor(props: { source: AmplitudeEventSource; clientId: string }) {
        super("create_task");
        this.props = props;
    }
}

export class DuplicateTaskEvent extends AmplitudeEvent {
    constructor() {
        super("duplicate_task");
    }
}

export class AssignTaskTitleEvent extends AmplitudeEvent {
    constructor(props: { source: AmplitudeEventSource }) {
        super("assign_task_title");
        this.props = props;
    }
}

export class DeleteTaskEvent extends AmplitudeEvent {
    constructor(props: { source: AmplitudeEventSource }) {
        super("delete_task");
        this.props = props;
    }
}

export class CompleteTaskEvent extends AmplitudeEvent {
    constructor(props: {
        source: AmplitudeEventSource;
        type: "singular" | "recurring";
        clientId?: string;
        masterId?: string;
        index?: number;
    }) {
        super("complete_task");
        this.props = props;
    }
}

export class MakeTaskRecurEvent extends AmplitudeEvent {
    constructor(props: {
        source: AmplitudeEventSource;
        // we might need to change this prop when we start to support more complicated rules.
        frequency: string;
    }) {
        super("make_task_recur");
        this.props = props;
    }
}

export class StartTaskTimerEvent extends AmplitudeEvent {
    constructor(props: { source: AmplitudeEventSource; taskId: string; taskDuration: number }) {
        super("start_task_timer");
        this.props = props;
    }
}
